import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { ConstitucionDelCreditoCreditosModel, CreditosModel } from './creditos.model';
import { CreditosListComponent } from './creditos-list.component';
import { CreditosService } from './creditos.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-creditosconstitucioncredito',
    templateUrl: './creditos-dialog-constitucion-credito.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosDialogConstitucionCreditoComponent implements OnInit {

  public creditos: CreditosModel = this.data.creditos;

  public constitucionDelCreditoCreditos: ConstitucionDelCreditoCreditosModel = new ConstitucionDelCreditoCreditosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  public dataSource: ConstitucionDelCreditoCreditosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'comisionApertura', title: 'Comisión Apertura', cell: (row) => `${row.comisionApertura}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporte: boolean = false;
  public invalidBankAccount: boolean = false;

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreditosListComponent>,
    public creditosService: CreditosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,

  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

      this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
            this.isProjectEnable = activity.isProject;
          });

    // Asignamos el valor de Plazo/Duracion ( Corto plazo o Largo plazo )
    this.constitucionDelCreditoCreditos.plazo = this.creditos.duracion;

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      });

    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    })

    this.getData();
  }

  public pay(): void {
  this.constitucionDelCreditoCreditos.creditosId = this.creditos.uid;

  let noError: boolean = true;

  // 🔹 Validaciones
  if (!this.constitucionDelCreditoCreditos.fecha) {
    noError = false;
    this.invalidDate = true;
  }

  if (!this.constitucionDelCreditoCreditos.concepto || this.constitucionDelCreditoCreditos.concepto.trim() === '') {
  noError = false;
  this.invalidConcept = true;
}


  if (!this.constitucionDelCreditoCreditos.importe || this.constitucionDelCreditoCreditos.importe <= 0) {
    noError = false;
    this.invalidImporte = true;
  }

  if (!this.constitucionDelCreditoCreditos.bankAccountsUid || this.constitucionDelCreditoCreditos.bankAccountsUid === consts.EMPTY_GUID) {
    noError = false;
    this.invalidBankAccount = true;
  }

  // 🔹 Validación de project y expense (usando id)
  // if (!this.constitucionDelCreditoCreditos.projectUid || this.constitucionDelCreditoCreditos.projectUid === consts.EMPTY_GUID) {
  //   noError = false;
  //   this.displayInfo("Debe seleccionar un proyecto");
  // }

  // if (!this.constitucionDelCreditoCreditos.expenseProjectTypeUid || this.constitucionDelCreditoCreditos.expenseProjectTypeUid === consts.EMPTY_GUID) {
  //   noError = false;
  //   this.displayInfo("Debe seleccionar un tipo de gasto del proyecto");
  // }

  if (!noError) {
    this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    return;
  }

  // Asignamos duración
  this.constitucionDelCreditoCreditos.plazo = this.creditos.duracion;

  const request = this.isEditMode
    ? this.creditosService.constitucionDelCreditoUpdate(this.constitucionDelCreditoCreditos)
    : this.creditosService.constitucionDelCreditoCreate(this.constitucionDelCreditoCreditos);

  request
    .then(() => {
      this.depositSaved = true;
      this.getData();

      // 🔹 Limpiar modelo
      this.constitucionDelCreditoCreditos = new ConstitucionDelCreditoCreditosModel();
      this.constitucionDelCreditoCreditos.plazo = this.creditos.duracion;
      this.isEditMode = false;
      this.cdr.detectChanges();
    })
    .catch(() => {
      this.displayInfo("Ha ocurrido un error al guardar la constitución del crédito");
    });
}



  public getData(): void {
    this.depositSaved = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporte = false;
    this.invalidBankAccount = false;

    this.list = false;
    this.dataSource = [];

    this.creditosService.constitucionDelCreditoList(this.creditos.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
      })
      .catch(error => {
      });
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.creditosService.constitucionDelCreditoDelete(uidElement)
      .then(responseDelete => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar la constitucion del credito");
      });
  }

 public edit(uidElement: string): void {
  const elementSearched = this.dataSource.find(f => f.uid === uidElement);
  if (!elementSearched) return;

  this.isEditMode = true;
  this.depositSaved = false;

  this.constitucionDelCreditoCreditos = { ...elementSearched };
  this.cdr.detectChanges();
}


  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
